import { getDayAndMonth } from './getDayAndMonth';

// e.g. '4 декабря 2023'
export function getDayAndMonthAndYear(dateString) {
    const dayAndMonth = getDayAndMonth(dateString);
    const year = new Date(dateString).getFullYear();

    return dayAndMonth && year ? `${dayAndMonth} ${year}` : '';
}
